/* src/app/home/partials/vehicle-fleet-status-graph/vehicle-fleet-status-graph.component.scss */
b {
  color: #1e293b;
  font-size: 0.95rem;
}
hr {
  margin: 0.5rem 0 0.75rem;
  border-color: #eef2f6;
}
/*# sourceMappingURL=vehicle-fleet-status-graph.component.css.map */
